import { axiosInstance } from './config';

export const lang_req = async (userId, lang) => {
    const response = await axiosInstance.post(`/setLang`, {
        uid: userId,
        lang: lang,
    });
    return response.data;
};
